module.exports = __webpack_public_path__ + "img/Flag_of_the_Philippines.8f4b3b5a.svg";